<template>
  <ChartTab
    :product="product"
    :product-data="productData"
    :subscription="subscription"
  />
</template>

<script lang="ts" setup>
import ChartTab from '~/components/price-assessments/ChartTab.vue'
import type { TProduct, TProductData } from '~/src/types/product.ts'
import { BLACK_MASS, MARKET } from '~/constants/services/constants'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ isTab: true })

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${BLACK_MASS.name} Prices`,
  description: `Access real-time and historic black mass prices from Benchmark, with expert supply/demand analysis and market commentary.`,
})
useHead(seo)

/*-------------------------------------
  Props & Refs
-------------------------------------*/
defineProps<{
  product: TProduct
  subscription: string
  productData: TProductData
}>()
</script>
